//import statement
import { useWallet } from "@solana/wallet-adapter-react";
import {
  WalletDisconnectButton,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";
import React from "react";
import { Row, Col, Button, ButtonGroup } from "react-bootstrap";
import MyRaffles from "../components/MyRaffles/MyRaffles";
import useRaffles from "../hooks/useRaffles";
import { BsFillArrowLeftCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

//functional component
const PageName = ({ name, backArrow, setRaffleSelector, raffleSelector }) => {
  const { stakerInfo } = useRaffles();
  const navigate = useNavigate();

  const wallet = useWallet();
  const [toggleMyRaffles, setToggleMyRaffles] = React.useState(false);

  return (
    <div className="">
      <Row className="page_name ">
        <Col
          md="6"
          sm="12"
          className="text-md-left text-center px-0 d-flex my-sm-4"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          {backArrow == "show" ? (
            <BsFillArrowLeftCircleFill className="mb-1 mx-2" size={23} />
          ) : null}{" "}
          <h2>{name}</h2>
        </Col>
        <Col
          md="6"
          sm="12"
          className="text-md-right my-4 text-center wallet-buttons"
        >
          {wallet.connected && stakerInfo.address && (
            <span>$GOD: {((stakerInfo?.tokens || 0) / 1000).toFixed(1)}</span>
          )}
          {wallet.connected ? (
            <WalletDisconnectButton className="disconnect" />
          ) : (
            <WalletMultiButton className="connect" />
          )}
          {/* <Button variant='outline-light' className="connect">CONNECT</Button> */}
          {wallet.connected && (
            <Button
              variant="outline-danger"
              className="my-raffle"
              onClick={() => setToggleMyRaffles(!toggleMyRaffles)}
            >
              MY RAFFLES
            </Button>
          )}
        </Col>
      </Row>

      <MyRaffles
        show={toggleMyRaffles}
        toggleShow={setToggleMyRaffles}
      ></MyRaffles>
    </div>
  );
};
export default PageName;
